module.exports = __webpack_public_path__ + "static/media/6.8b52e6c0.jpeg";